"use client"

import { Shield, Target, Compass, BookOpen } from "lucide-react"
import { motion } from "framer-motion"

const VALUES = [
  {
    icon: Shield,
    title: "Institutional Integrity",
    desc: "Rigorous standards derived from official administrative guidelines."
  },
  {
    icon: Target,
    title: "Surgical Precision",
    desc: "Curriculum designed to hit the precise requirements of the syllabus."
  },
  {
    icon: Compass,
    title: "Admin Mentorship",
    desc: "Direct guidance from those who have served in the highest ranks."
  },
  {
    icon: BookOpen,
    title: "Curated Archives",
    desc: "The largest digital vault of case studies and year-marked archives."
  }
]

export default function ValuesSection() {
  return (
    <section className="bg-white py-10 sm:py-14 overflow-hidden border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        
        {/* Subtle Section Header */}
        <div className="flex flex-col items-center text-center mb-10">
           <div className="w-12 h-px bg-[#b48c36]/20 mb-6" />
           <h2 className="text-[10px] font-bold uppercase tracking-[0.5em] text-[#b48c36] mb-4">The Academy Ethos</h2>
           <p className="font-serif text-3xl sm:text-4xl text-slate-900  font-light">Precision in every pillar.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 sm:gap-16">
          {VALUES.map((val, i) => {
            const Icon = val.icon
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="flex flex-col items-center text-center group"
              >
                <div className="w-16 h-16 rounded-full bg-slate-50 flex items-center justify-center text-slate-900 mb-6 group-hover:bg-[#b48c36] group-hover:text-white transition-all duration-500 shadow-inner">
                  <Icon size={28} strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-xl font-bold text-slate-950 mb-3 tracking-tight">
                  {val.title}
                </h3>
                <p className="text-xs text-slate-400 leading-relaxed font-medium">
                  {val.desc}
                </p>
              </motion.div>
            )
          })}
        </div>



      </div>
    </section>
  )
}
